import type { Table } from '@tanstack/react-table';

export const FAMILY_STUDENT_CAROUSEL_DIRECTION = {
  PREV: 'prev',
  NEXT: 'next',
} as const;

export type FamilyStudentCarouselDirection =
  (typeof FAMILY_STUDENT_CAROUSEL_DIRECTION)[keyof typeof FAMILY_STUDENT_CAROUSEL_DIRECTION];

export interface FamilyStudentCarouselPosition {
  selectedIndex: number;
  slideCount: number;
  canScrollPrev: boolean;
  canScrollNext: boolean;
}

export interface StudentByFamilyMobileCarouselProps<TData> {
  table: Table<TData>;
  isUpdating?: boolean;
}
